import { DateDetailsComponent } from './date-details/date-details.component';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbTabChangeEvent, NgbModal, NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { GLOBAL, ROLECODE } from 'src/app/app.globals';
import { SharedService } from 'src/app/core/services';
import * as moment from 'moment';
import { VerifyComponent } from './verify/verify.component';
import { GatePassRequestsService } from '../gate-pass-requests.service';
import { LogHelperService } from 'src/app/core/services/log-helper.service';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import { OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { CookieService } from 'ngx-cookie-service';
import * as _ from 'lodash';
import { CommentComponent } from './comment/comment.component';
import { FileDoc, FileUploadService } from 'src/app/core/components';
import { DataShareService } from 'src/app/service/data-share.service';
import { ApiCallService } from 'src/app/service/api-call.service';

const browserWindow = window || {};
const browserWindowEnv = browserWindow['__env'] || {};

const dateFormat = 'DD-MM-YYYY';
export const MY_MOMENT_FORMATS = {
  parseInput: dateFormat,
  fullPickerInput: dateFormat,
  datePickerInput: dateFormat,
  timePickerInput: dateFormat,
  monthYearLabel: dateFormat,
  dateA11yLabel: dateFormat,
  monthYearA11yLabel: dateFormat,
};
let newdate: Date;
let newdate1: Date;
const today = new Date();
const today1 = (new Date(today)).toLocaleDateString();

@Component({
  selector: 'app-approval-flow',
  templateUrl: './approval-flow.component.html',
  styleUrls: ['./approval-flow.component.css'],
  providers: [{ provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
  { provide: OWL_DATE_TIME_LOCALE, useValue: 'en-IN' }]
})
export class ApprovalFlowComponent implements OnInit {

  public userAllowedForNewRequestForHRTab = [118, 121, 122];
  public allowedUserForNewRequestForHRTab = [];
  public allowedUserRoleForActionSaveValidation = [101, 103, 118, 120, 121, 122];

  @ViewChild(NgbTabset) public tabSet: NgbTabset;
  public hideVerificationSection: boolean;
  @Input() resolveObject;
  @Input() requestType;
  @Input() Request_Code;
  @Input() ApprovalWorkFlowDetails;
  @Input() reqApprovalInfo;
  UserDataAccessData: any;
  approvalData: any = {};
  labourDoc = [];
  show = true;
  hrApproved = false;
  public activedate = false;
  public gpvaliditydate = false;
  public disableenrollment = false;
  public disablegpissue = false;
  disablegpreturned = false;
  disablegpdeactivated = false;
  tabstatus = 'N';
  verifybutton = false;
  // updatebutton = true;
  roleCode = JSON.parse(localStorage.getItem('Role'));
  action = '';
  approve = '';
  enableAction = false;
  enableActionSaveBtn = false;
  documents = [];
  sections = [];
  cardType: any[];
  masterData = [];
  regularweekly: { Id: number, Name: string; }[];
  shiftGroup = [];
  siteshiftGroup = [];
  ohc = false;
  ehs = false;
  security = false;
  disableEyetestingField = false;
  public hrTabAllowedUser = false;
  hrverify = false;
  ageLimitDay: number;
  ageLimitDepend: number;
  section;
  labourStatus = "Active"
  nextDueDateCount: number
  public isVerifyPf;
  private globalSettings: any;
  public isOHCRoleCode: boolean = false;
  globalSettingList: any = [];
  IsPrviousApproved: any = 0;
  documentUrl = GLOBAL.BASE_URL_DOC;

  isOlderVariable: boolean = false;

  uploadedFiles: FileDoc[] = [];
  copyUploadedFiles: FileDoc[] = []
  public allowedFileTypes: any = GLOBAL.ALLOWED_FILE_TYPES;
  public maxSizeAllowed: any = "";
  documentTypes = [];

  constructor(
    private modalService: NgbModal,
    private gatePassRequestsService: GatePassRequestsService,
    public sharedService: SharedService,
    public activeModal: NgbActiveModal,
    private logHelperService: LogHelperService,
    private fileUploadService: FileUploadService,
    public sharedDataService: SharedDataService,
    private cookieService: CookieService,
    private apiCall: ApiCallService,
    private dataShareService: DataShareService,
  ) { }

  currentAge: any
  isRoleAllowed: boolean = false;
  isIssueDateAllowed: boolean = false;
  reportingTo: any[] = [];

  ngOnInit() {
    const allowedRoles = [118, 120, 108];
    this.isRoleAllowed = allowedRoles.includes(GLOBAL.ROLE_CODE)

    this.getReportingTo();

    if (this.resolveObject.RequestType_Code === 104) {
      const allowedIssueDateRoles = [118];
      this.isIssueDateAllowed = allowedIssueDateRoles.includes(GLOBAL.ROLE_CODE)
    }
    this.currentAge = this.calculateAge(this.resolveObject.labourData.DOB ? this.resolveObject.labourData.DOB : null);
    const userRoles = JSON.parse(localStorage.getItem('Role'));

    const promise1 = new Promise((resolve, reject) => {
      this.gatePassRequestsService.getRolePermission({
        "Request_Code": this.Request_Code,
        "RequireType": 0,
        "ActionType": 0,
        "UserId": GLOBAL.USER_ID
      }).subscribe((res: any) => {
        if (res.length) {
          this.IsPrviousApproved = res[0].IsPrviousApproved;
        }
        resolve(res);
      }, (error) => reject(error));
    });

    const promise2 = new Promise((resolve, reject) => {
      this.gatePassRequestsService.globalSettingCode('').subscribe((res: any) => {
        this.globalSettingList = res.Data.Table;
        let roleCode = res.Data.Table.find(item => item.Code === 'MOD52PG195REQVERYN');
        this.nextDueDateCount = res.Data.Table.find(item => item.Code === 'MOD152PG195GPMEDVDT_1').Value;
        this.ageLimitDepend = res.Data.Table.find(item => item.Code === 'MOD152PG195GPMEDVDT_3').Value;
        this.ageLimitDay = res.Data.Table.find(item => item.Code === 'MOD152PG195GPMEDEYEAGE').Value;
        this.allowedUserForNewRequestForHRTab = res.Data.Table.find(item => item.Code === 'MOD52PG195REQVERROLL').Role;

        let isUserRoleCodeFound = userRoles.some(role =>
          this.allowedUserForNewRequestForHRTab.includes(role.Role_Code)
        );

        this.isVerifyPf = isUserRoleCodeFound && roleCode.Value === "1";

        resolve(res);
      }, (error) => reject(error));
    });

    Promise.all([promise1, promise2]).then((res) => {
      this.hideFooterForContractor();
      this.tabvalidation();
      this.setActiveTabByRole();

      if (this.resolveObject.RequestType_Code === 105) {
        this.disablegpreturned = true;
        this.disablegpdeactivated = true;
      } else {
        this.disablegpreturned = false;
        this.disablegpdeactivated = false;
      }

      this.resolveObject.labourData.ReqApprovalInfo.forEach((row) => {
        if (row.Role_Code === 111) {
          // this.disableenrollment = true;
          this.disablegpissue = true;
        } else {
          // this.disableenrollment = false;
          this.disablegpissue = false;
        }
      });
      if (this.resolveObject.labourData.IsSuspended === 1) {
        this.labourStatus = "Debarrded";
      } else if (this.resolveObject.labourData.IsSuspended === 2) {
        if (this.resolveObject.labourData.SuspendEndDate) {
          const endDate = moment(this.resolveObject.labourData.SuspendEndDate);
          const diff = endDate.diff(
            moment(moment().format("YYYY-MM-DD")),
            "days"
          );
          if (
            diff > 0 ||
            endDate.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")
          ) {
            this.labourStatus = "Suspended";
          } else {
            this.labourStatus = "Active";
          }
        } else {
          this.labourStatus = "Suspended";
        }
      } else {
        this.labourStatus = "Active";
      }
      this.approvalData = this.resolveObject.approvalData;
      this.disableActionSaveBtn(this.approvalData);

      // this.approvalData.gatepassValidityDate = moment(this.approvalData.MaxValiditydate, 'M/DD/YYYY').toDate();
      const d = this.globalSettingList.find(item => item.Code === 'MOD152PG195GPVDT');
      this.approvalData.MaxValiditydate = moment(this.approvalData.MaxValiditydate).add(d && d.Value ? Number(d.Value) : 0, 'days').format('YYYY-MM-DD');
      this.approvalData.gatepassValidityDate = this.approvalData.gatepassValidityDate ? moment(this.approvalData.gatepassValidityDate).toDate() : null;
      this.approvalData.CheckUpDate = this.approvalData.CheckUpDate ? moment(this.approvalData.CheckUpDate).toDate() : null;
      this.approvalData.NextScheduledate = this.approvalData.FNSNextScheduledate ? moment(this.approvalData.FNSNextScheduledate).toDate() : null;
      this.approvalData.OHCNextDuedate = this.approvalData.OHCNextDuedate ? moment(this.approvalData.OHCNextDuedate).toDate() : null;
      this.approvalData.XrayValidityDate = this.approvalData.XrayValidityDate ? moment(this.approvalData.XrayValidityDate).toDate() : null;
      this.approvalData.EyeTestingValidityDate = this.approvalData.EyeTestingValidityDate ? moment(this.approvalData.EyeTestingValidityDate).toDate() : null;
      this.approvalData.ReExamingDate = this.approvalData.ReExamingDate ? moment(this.approvalData.ReExamingDate).toDate() : null;
      this.approvalData.FitnessStatus = this.approvalData.FitnessStatus ? parseInt(this.approvalData.FitnessStatus) : null;
      this.approvalData.FNSNextDuedate = this.approvalData.FNSNextDuedate ? moment(this.approvalData.FNSNextDuedate).toDate() : null;
      this.approvalData.FNSNextScheduledate = this.approvalData.FNSNextScheduledate ? moment(this.approvalData.FNSNextScheduledate).toDate() : null;
      this.approvalData.FNSTraningStatus = this.approvalData.FNSTraningStatus ? parseInt(this.approvalData.FNSTraningStatus) : null;
      
      const dates = [];
      this.approvalData.ECPolicyValidityDat ? dates.push(new Date(this.approvalData.ECPolicyValidityDate)) : null;
      this.approvalData.LicenseValidityDate ? dates.push(new Date(this.approvalData.LicenseValidityDate)) : null;
      this.approvalData.POValidityDate ? dates.push(new Date(this.approvalData.POValidityDate)) : null;
      this.approvalData.MaxValiditydate ? dates.push(new Date(this.approvalData.MaxValiditydate)) : null;
      this.approvalData.MedicalValidityDate ? dates.push(new Date(this.approvalData.MedicalValidityDate)) : null;
      this.approvalData.InductionTrainingDate ? dates.push(new Date(this.approvalData.InductionTrainingDate)) : null;
      this.approvalData.XrayValidityDate ? dates.push(new Date(this.approvalData.XrayValidityDate)) : null;
      this.approvalData.EyeTestingValidityDate ? dates.push(new Date(this.approvalData.EyeTestingValidityDate)) : null;

      this.approvalData.minValidityDate = _.min(dates);
      this.approvalData.gatepassValidityDate = this.approvalData.minValidityDate;
      // this.approvalData.SiteShiftGroup_Code = this.approvalData.SiteShiftGroup_Code ? this.approvalData.SiteShiftGroup_Code : null;
      this.approvalData.HrComment = this.approvalData.HrComment ? this.approvalData.HrComment : null;

      this.labourDoc = this.resolveObject.labourDoc;
      this.hrApproved = this.resolveObject.hrApproved;
      // this.getAllSections();
      this.getMasterdata();
      // this.shiftGroupData();
      // this.siteshiftGroupData();
      // if(this.approvalData.Photo != undefined){
      //   if(/\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(this.approvalData.Photo)){
      //     this.approvalData.Photo = `${GLOBAL.PHOTO_URL}${this.approvalData.Photo}`;
      //   }else{
      //     this.approvalData.Photo = `${this.approvalData.Photo}`;
      //   }
      // }
      this.isOHCRoleCode = userRoles.findIndex(role => role.Role_Code == 109) >= 0 ? true : false;
      const isRoleExist = userRoles.some(x => this.allowedUserForNewRequestForHRTab.includes(x.Role_Code));

      if (isRoleExist && this.approvalData.RequestTypeName == 'New Request') {
        this.enableAction = false;
        // this.verifybutton = true;
        if (this.resolveObject.labourData && this.resolveObject.labourData.ULC) {
          this.verifybutton = false;
        } else {
          this.verifybutton = true;
        }
      } else {
        this.enableAction = true;
        this.verifybutton = false;
      }

      // if (JSON.parse(localStorage.getItem('Role'))[0].Role_Code === 119) {
      //   this.updatebutton = true;
      // } else {
      //   this.updatebutton = false;
      // }

      if (this.approvalData.IsVerifyEPF === true) {
        this.hrverify = false;
        this.approvalData.verificationDate = (new Date(this.approvalData.verificationDate)).toLocaleDateString();
        this.approvalData.ESICVerificationDate = (new Date(this.approvalData.ESICVerificationDate)).toLocaleDateString();
        this.approvalData.PFExtendedDate = (new Date(this.approvalData.PFExtendedDate)).toLocaleDateString();
        this.approvalData.ESICExtendedDate = (new Date(this.approvalData.ESICExtendedDate)).toLocaleDateString();


        this.approvalData.verificationDate = this.approvalData.verificationDate;
        this.approvalData.ESICVerificationDate = this.approvalData.ESICVerificationDate;
        this.approvalData.PFExtendedDate = this.approvalData.PFExtendedDate;
        this.approvalData.ESICExtendedDate = this.approvalData.ESICExtendedDate;


        this.approvalData.UserforEPF = this.approvalData.UserName;
        this.approvalData.UserforESIC = this.approvalData.UserName;
      } else if (this.approvalData.IsVerifyESIC === true) {
        this.hrverify = false;
        this.approvalData.verificationDate = (new Date(this.approvalData.verificationDate)).toLocaleDateString();
        this.approvalData.ESICVerificationDate = (new Date(this.approvalData.ESICVerificationDate)).toLocaleDateString();
        this.approvalData.PFExtendedDate = (new Date(this.approvalData.PFExtendedDate)).toLocaleDateString();
        this.approvalData.ESICExtendedDate = (new Date(this.approvalData.ESICExtendedDate)).toLocaleDateString();


        this.approvalData.verificationDate = this.approvalData.verificationDate;
        this.approvalData.ESICVerificationDate = this.approvalData.ESICVerificationDate;
        this.approvalData.PFExtendedDate = this.approvalData.PFExtendedDate;
        this.approvalData.ESICExtendedDate = this.approvalData.ESICExtendedDate;


        this.approvalData.UserforEPF = this.approvalData.UserName;
        this.approvalData.UserforESIC = this.approvalData.UserName;
      }
    })

    // this.sharedService.globalSettingsDataSource$.subscribe((settings: any) => {
    //   if (settings && settings.Data && settings.Data.Table) {
    //     this.globalSettings = settings.Data.Table;
    //   }
    // });
    // this.isVerifyPf = this.globalSettings.find(setting => setting.Code === browserWindowEnv.PF_VERIFICATION_CHECK);


    if (this.resolveObject.RequestType_Code === 105) {
      this.disablegpreturned = true;
      this.disablegpdeactivated = true;
    } else {
      this.disablegpreturned = false;
      this.disablegpdeactivated = false;
    }

    this.resolveObject.labourData.ReqApprovalInfo.forEach((row) => {
      if (row.Role_Code === 111) {
        // this.disableenrollment = true;
        this.disablegpissue = true;
      } else {
        // this.disableenrollment = false;
        this.disablegpissue = false;
      }
    });
    if (this.resolveObject.labourData.IsSuspended === 1) {
      this.labourStatus = "Debarrded";
    } else if (this.resolveObject.labourData.IsSuspended === 2) {
      if (this.resolveObject.labourData.SuspendEndDate) {
        const endDate = moment(this.resolveObject.labourData.SuspendEndDate);
        const diff = endDate.diff(
          moment(moment().format("YYYY-MM-DD")),
          "days"
        );
        if (
          diff > 0 ||
          endDate.format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")
        ) {
          this.labourStatus = "Suspended";
        } else {
          this.labourStatus = "Active";
        }
      } else {
        this.labourStatus = "Suspended";
      }
    } else {
      this.labourStatus = "Active";
    }
    this.approvalData = this.resolveObject.approvalData;
    this.disableActionSaveBtn(this.approvalData);
    // this.approvalData.gatepassValidityDate = moment(this.approvalData.MaxValiditydate, 'M/DD/YYYY').toDate();
    const d = this.globalSettingList.find(item => item.Code === 'MOD152PG195GPVDT');
    this.approvalData.MaxValiditydate = moment(this.approvalData.MaxValiditydate).add(d && d.Value ? Number(d.Value) : 0, 'days').format('YYYY-MM-DD');
    this.approvalData.gatepassValidityDate = this.approvalData.gatepassValidityDate ? moment(this.approvalData.gatepassValidityDate).toDate() : null;
    this.approvalData.CheckUpDate = this.approvalData.CheckUpDate ? moment(this.approvalData.CheckUpDate).toDate() : null;
    this.approvalData.NextScheduledate = this.approvalData.FNSNextScheduledate ? moment(this.approvalData.FNSNextScheduledate).toDate() : null;
    this.approvalData.OHCNextDuedate = this.approvalData.OHCNextDuedate ? moment(this.approvalData.OHCNextDuedate).toDate() : null;
    this.approvalData.XrayValidityDate = this.approvalData.XrayValidityDate ? moment(this.approvalData.XrayValidityDate).toDate() : null;
    this.approvalData.EyeTestingValidityDate = this.approvalData.EyeTestingValidityDate ? moment(this.approvalData.EyeTestingValidityDate).toDate() : null;
    this.approvalData.ReExamingDate = this.approvalData.ReExamingDate ? moment(this.approvalData.ReExamingDate).toDate() : null;
    const dates = [];
    this.approvalData.ECPolicyValidityDat ? dates.push(new Date(this.approvalData.ECPolicyValidityDate)) : null;
    this.approvalData.LicenseValidityDate ? dates.push(new Date(this.approvalData.LicenseValidityDate)) : null;
    this.approvalData.POValidityDate ? dates.push(new Date(this.approvalData.POValidityDate)) : null;
    this.approvalData.MaxValiditydate ? dates.push(new Date(this.approvalData.MaxValiditydate)) : null;
    this.approvalData.MedicalValidityDate ? dates.push(new Date(this.approvalData.MedicalValidityDate)) : null;
    this.approvalData.InductionTrainingDate ? dates.push(new Date(this.approvalData.InductionTrainingDate)) : null;
    this.approvalData.XrayValidityDate ? dates.push(new Date(this.approvalData.XrayValidityDate)) : null;
    this.approvalData.EyeTestingValidityDate ? dates.push(new Date(this.approvalData.EyeTestingValidityDate)) : null;

    this.approvalData.minValidityDate = _.min(dates);
    this.approvalData.gatepassValidityDate = this.approvalData.minValidityDate;
    // this.approvalData.SiteShiftGroup_Code = this.approvalData.SiteShiftGroup_Code ? this.approvalData.SiteShiftGroup_Code : null;
    this.approvalData.HrComment = this.approvalData.HrComment ? this.approvalData.HrComment : null;

    this.labourDoc = this.resolveObject.labourDoc;
    this.hrApproved = this.resolveObject.hrApproved;
    this.getAllSections();
    this.getMasterdata();
    // this.shiftGroupData();
    this.siteshiftGroupData();

    if (this.approvalData.Photo) {
      if (/\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(this.approvalData.Photo)) {
        this.approvalData.Photo = `${GLOBAL.PHOTO_URL}${this.approvalData.Photo}`;
      } else {
        this.approvalData.Photo = `${this.approvalData.Photo}`;
      }
      //this.approvalData.Photo = GLOBAL.PHOTO_URL + this.approvalData.Photo;
    }
    const isRoleExist = userRoles.some(x => this.userAllowedForNewRequestForHRTab.includes(x.Role_Code));
    if (isRoleExist && this.approvalData.RequestTypeName == 'New Request') {
      this.enableAction = false;
      // this.verifybutton = true;
      if (this.resolveObject.labourData && this.resolveObject.labourData.ULC) {
        this.verifybutton = false;
      } else {
        this.verifybutton = true;
      }
    } else {
      this.enableAction = true;
      this.verifybutton = false;
    }

    // if (JSON.parse(localStorage.getItem('Role'))[0].Role_Code === 119) {
    //   this.updatebutton = true;
    // } else {
    //   this.updatebutton = false;
    // }

    if (this.approvalData.IsVerifyEPF === true) {
      this.hrverify = false;
      this.approvalData.verificationDate = (new Date(this.approvalData.verificationDate)).toLocaleDateString();
      this.approvalData.ESICVerificationDate = (new Date(this.approvalData.ESICVerificationDate)).toLocaleDateString();
      this.approvalData.PFExtendedDate = (new Date(this.approvalData.PFExtendedDate)).toLocaleDateString();
      this.approvalData.ESICExtendedDate = (new Date(this.approvalData.ESICExtendedDate)).toLocaleDateString();


      this.approvalData.verificationDate = this.approvalData.verificationDate;
      this.approvalData.ESICVerificationDate = this.approvalData.ESICVerificationDate;
      this.approvalData.PFExtendedDate = this.approvalData.PFExtendedDate;
      this.approvalData.ESICExtendedDate = this.approvalData.ESICExtendedDate;


      this.approvalData.UserforEPF = this.approvalData.UserName;
      this.approvalData.UserforESIC = this.approvalData.UserName;
    } else if (this.approvalData.IsVerifyESIC === true) {
      this.hrverify = false;
      this.approvalData.verificationDate = (new Date(this.approvalData.verificationDate)).toLocaleDateString();
      this.approvalData.ESICVerificationDate = (new Date(this.approvalData.ESICVerificationDate)).toLocaleDateString();
      this.approvalData.PFExtendedDate = (new Date(this.approvalData.PFExtendedDate)).toLocaleDateString();
      this.approvalData.ESICExtendedDate = (new Date(this.approvalData.ESICExtendedDate)).toLocaleDateString();


      this.approvalData.verificationDate = this.approvalData.verificationDate;
      this.approvalData.ESICVerificationDate = this.approvalData.ESICVerificationDate;
      this.approvalData.PFExtendedDate = this.approvalData.PFExtendedDate;
      this.approvalData.ESICExtendedDate = this.approvalData.ESICExtendedDate;


      this.approvalData.UserforEPF = this.approvalData.UserName;
      this.approvalData.UserforESIC = this.approvalData.UserName;
    }
    // const http = new XMLHttpRequest();
    // http.open('HEAD', url, false);
    // http.send();
    // if (http.status !== 404) {
    //   this.approvalData.Photo = url;
    // } else {
    //   this.approvalData.Photo = || 'assets/Image/blank-face.jpg''assets/Image/blank-face.jpg';
    // }

    // if (this.approve == 'ActionSave') {
    //   this.actionSave();
    // } else if (this.approve == 'UpdateAction') {
    //   this.actionUpdate();
    // }
    this.gatePassRequestsService.getUserDataAccessDetails({
      "RequestType": 0, "ActionType": 0, "UserId": GLOBAL.USER_ID
    }).subscribe((res: any) => {
      this.UserDataAccessData = res;
    });

    this.getDocumentTypes();
    this.sharedService.globalMasterSettingData().subscribe((res: any) => {
      if (res.Data.Table) {
        this.globalSettings = res.Data.Table;
        this.maxSizeAllowed = Number(this.globalSettings.find((item) => item.Code === "DOCSIZEL1").Value) * 1024;
        this.allowedFileTypes = this.globalSettings.find((item) => item.Code === "DOCFORMATL1").Value;
      }
    });
  }

  getReportingTo() {
    const reqObj = {
      WorkOrder_Code: this.resolveObject.labourData.WorkOrder_Code
    }

    this.apiCall.getWorkOrderList(reqObj).subscribe((response) => {
      this.reportingTo = response;
    });
  }

  getDocumentTypes() {
    const res = {
      Page_Code: 196,
      RequireType: 1,
      ActionType: 0,
      UserId: GLOBAL.USER_ID,
      Search: null,
      SelectedField: "Name,DocumentType_Code,page_code",
    };
    this.gatePassRequestsService.getDocumentTypesPageModuleWise(res).subscribe((docTypes: any) => {
      this.documentTypes = docTypes;
    });
  }


  calculateAge(dobString: string): { years: number; months: number; days: number } {
    const dob = new Date(dobString);
    const today = new Date();

    let years = today.getFullYear() - dob.getFullYear();
    let months = today.getMonth() - dob.getMonth();
    let days = today.getDate() - dob.getDate();

    if (days < 0) {
      months -= 1;
      const previousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += previousMonth.getDate();
    }
    if (months < 0) { years -= 1; months += 12; }
    this.isOlderVariable = years > 60;
    return { years, months, days };
  }

  onFilesChanged(newFiles: any) {
    const set = new Set(newFiles.filter(item => {
      if (item.ID) {
        return item.ID
      }
    }));
    const result = [];
    for (const item of this.copyUploadedFiles) {
      if (!set.has(item.ID)) {
        result.push(item);
      }
    }

  }

  onCheckedChangeFunc($event) {
    this.approvalData.XrayValidityDate = '';
    if ($event.target.value == "YES") {
      //let checkupdate = this.approvalData.CheckUpDate;
      //this.approvalData.XrayValidityDate = checkupdate.add(this.nextDueDateCount, 'days');
      let checkupdate = moment(this.approvalData.CheckUpDate, "DD-MM-YYYY").toDate();
      let someDate = new Date(checkupdate.getFullYear() + '-' + (checkupdate.getMonth() + 1) + '-' + checkupdate.getDate());
      let result = someDate.setDate(someDate.getDate() + Number(this.nextDueDateCount));
      this.approvalData.XrayValidityDate = new Date(result);
    } else {
      this.approvalData.XrayValidityDate = '';
    }
    //this.selectedUsers[parentIndex]['items'][itemIndex][field] =  new Date(result);
  }
  onCheckedChangeEyeFunc($event) {
    this.approvalData.EyeTestingValidityDate = '';
    let targVal = "NO";
    let getDays = 0;
    if ($event == "YES") {
      targVal = "YES"
    } else {
      targVal = $event.target.value == "YES" ? "YES" : "NO";
    }

    //if($event.target.value == "YES"){
    if (targVal == "YES") {
      if (this.ageLimitDepend == 0) {
        getDays = this.globalSettingList.find(item => item.Code === 'MOD152PG195GPMEDVDT_2').Value;
      } else if (this.ageLimitDepend == 1) {
        let timeDiff = Math.abs(Date.now() - new Date(this.approvalData.dob).getTime());
        let age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
        if (this.ageLimitDay <= age) {
          getDays = this.globalSettingList.find(item => item.Code === 'MOD152PG195GPMEDEYEAGE_B').Value;
        } else if (this.ageLimitDay >= age) {
          getDays = this.globalSettingList.find(item => item.Code === 'MOD152PG195GPMEDEYEAGE_A').Value;
        }
      }

      let checkupdate = moment(this.approvalData.CheckUpDate, "DD-MM-YYYY").toDate();
      let someDate = new Date(checkupdate.getFullYear() + '-' + (checkupdate.getMonth() + 1) + '-' + checkupdate.getDate());
      let result = someDate.setDate(someDate.getDate() + Number(getDays));
      this.approvalData.EyeTestingValidityDate = new Date(result);
    } else {
      this.approvalData.EyeTestingValidityDate = '';
    }
  }
  getEyeTestingDynClass(tradeCode) {
    let fieldVal = this.globalSettingList.find(item => item.Code === 'MOD152PG195GPMEDEYEV').Value;
    if (fieldVal == 0) {
      this.disableEyetestingField = false;
      return 'non-mandatory inputcolor';
    } else if (fieldVal == 1) {
      if (this.approvalData.CheckUpDate && this.approvalData.FitnessStatus == 1126) {
        this.approvalData.eyetestingrequired = "YES";
        this.disableEyetestingField = true;
      }
      // this.onCheckedChangeEyeFunc(true);
      return 'mandatory inputcolor';
    } else if (fieldVal == 2) {
      let tradeCodes = this.globalSettingList.find(item => item.Code === 'MOD152PG195GPMEDTRED_1').Value;
      if (tradeCodes != null && tradeCodes != '') {
        const array = tradeCodes.split(',');
        if (array.includes(tradeCode)) {
          if (this.approvalData.CheckUpDate && this.approvalData.FitnessStatus == 1126) {
            this.approvalData.eyetestingrequired = "YES";
            this.disableEyetestingField = true;
          }
        } else {
          this.approvalData.eyetestingrequired = "No";
          this.disableEyetestingField = false;
        }
        return array.includes(tradeCode) ? 'mandatory inputcolor' : 'non-mandatory inputcolor';
      } else {
        this.disableEyetestingField = false;
        this.approvalData.eyetestingrequired = "No";
        return 'non-mandatory inputcolor';
      }
    }
  }
  private disableActionSaveBtn(data: any) {
    const roles = JSON.parse(localStorage.getItem('Role'));
    // const requiredRoles = [118, 121, 122];
    const isAllowed = roles.some(item => this.allowedUserForNewRequestForHRTab.includes(item.Role_Code));
    if (!data.ULCCode && isAllowed) {
      this.enableActionSaveBtn = true;
    }
  }

  stepclose(resData) {
    const data = {
      ULC: resData ? resData.ULC : this.approvalData.ULCCode,
      ShiftGroup: this.approvalData.SiteShiftGroup_Code,
      GatePassNo: resData ? resData.GatePassNo : this.approvalData.GatePassNo,
      isCancel: !resData
    };
    this.activeModal.close(data);
  }

  getBg1Class(IsSuspended: any, status: any) {
    if (status === "Active") {
      return "active-color";
    }
    if (IsSuspended == 2) {
      return "cancel-color";
    } else if (IsSuspended == 1) {
      return "debard-color";
    } else {
      return "active-color";
    }
  }

  getBgClass(IsSuspended: any, status: any) {
    if (status === "Active") {
      return "profile_img_green";
    }
    if (IsSuspended == 2) {
      return "profile_img_red";
    } else if (IsSuspended == 1) {
      return "profile_img_debard";
    } else {
      return "profile_img_green";
    }
  }

  getIconClass(IsSuspended: any, status: any) {
    if (status === "Active") {
      return "fa fa-check";
    }
    if (IsSuspended == 2) {
      return "icon-saDC-debarred1";
    } else if (IsSuspended == 1) {
      return "icon-saDC-debarred";
    } else {
      return "icon-saDC-debarred";
    }

  }

  getBg2Class(IsSuspended: any, status: any) {
    if (status === "Active") {
      return "status_text_green";
    }
    if (IsSuspended == 2) {
      return "status_text_red";
    } else if (IsSuspended == 1) {
      return "status_text_debard";
    } else {
      return "status_text_green";
    }
  }

  public tabChange(event: NgbTabChangeEvent) {
    if (event.nextId === 'tab-documents' && this.documents.length === 0) {
      this.getDocuments();
    }
  }

  openVerify() {
    const modalRef = this.modalService.open(VerifyComponent, { size: 'lg', backdrop: 'static', windowClass: 'verification-window' });
    modalRef.componentInstance.resolveObject = this.resolveObject;
    modalRef.result.then((result) => {
      if (result) {
        this.action = 'Approved';
        this.enableAction = true;
        this.approvalData.ULCCode = result.ULC;
        this.resolveObject.labourData.ULC = result.ULC;
        this.enableActionSaveBtn = false;
        this.verifybutton = false;
      }
    });
  }
  getXrayDynClass(tradeCode) {
    if (this.globalSettingList) {
      let fieldVal = this.globalSettingList.find(item => item.Code === 'MOD152PG195GPMEDXRAYV').Value;
      if (fieldVal == 0) {
        return 'non-mandatory inputcolor';
      } else if (fieldVal == 1) {
        return 'mandatory inputcolor';
      } else if (fieldVal == 2) {
        let tradeCodes = this.globalSettingList.find(item => item.Code === 'MOD152PG195GPMEDTRED_2').Value;
        if (tradeCodes != null && tradeCodes != '') {
          const array = tradeCodes.split(',');
          return array.includes(tradeCode) ? 'mandatory inputcolor' : 'non-mandatory inputcolor';
        } else {
          return 'non-mandatory inputcolor';
        }
      }
    }
  }
  chkFitnessStatus(value: string) {

  }
  chkFitnessStatus1(value: any) {
    if (value === 1126) {
      this.action = 'Approved';
    } else if (value === 1127) {
      this.action = 'Rejected';
    } else if (value === 1128) {
      this.action = 'Hold';
    } else {
      this.action = '';
    }
  }

  checkFNSTraningStatus(value: string) {

  }

  checkvalidation() {
    if (this.action == null || this.action === '') {
      this.logHelperService.logError({ message: 'Please select any action!' });
      return false;
    }
    if (JSON.parse(localStorage.getItem('Role'))[0].Role_Code === 109) {
      if (this.approvalData.FitnessStatus == null || this.approvalData.FitnessStatus == ''
        || this.approvalData.CheckUpDate == null || this.approvalData.CheckUpDate == '') {
        this.logHelperService.logError({ message: 'Plaese fill detail' });
        return false;
      }
    }
    if (JSON.parse(localStorage.getItem('Role'))[0].Role_Code === 110) {
      if (this.approvalData.FNSTraningStatus == null || this.approvalData.FNSTraningStatus === '') {
        this.logHelperService.logError({ message: 'Please select a status!' });
        return false;
      }
    }
    if (JSON.parse(localStorage.getItem('Role'))[0].Role_Code === 118) {
      if (!this.approvalData.SiteShiftGroup_Code) {
        this.logHelperService.logError({ message: 'Please select the Site Shift Group!' });
        return false;
      }
    }
    // if (JSON.parse(localStorage.getItem('Role'))[0].Role_Code === 118) {
    //   if (!this.approvalData.HrComment) {
    //     this.logHelperService.logError({ message: 'Please enter the comment!' });
    //     return false;
    //   }
    // }

    // if (this.allowedUserRoleForActionSaveValidation.includes(parseInt(GLOBAL.ROLE_CODE))) {
    //   if (this.isVerifyPf && this.approvalData.RequestTypeName == "New Request") {
    //     if (!this.approvalData.IsVerifyEPF || !this.approvalData.EPFNo) {
    //       this.logHelperService.logError({ message: 'PF number is not found or PF verification is pending.' });
    //       return false;
    //     }
    //   }
    //   if (this.approvalData.ESICWageCriteria && this.approvalData.RequestTypeName == "New Request") {
    //     if (!this.approvalData.IsVerifyESIC || !this.approvalData.ESICNo) {
    //       this.logHelperService.logError({ message: 'ESIC number is not found or ESIC verification is pending.' });
    //       return false;
    //     }
    //   }
    // }
    return true;
  }

  prepareReqForActionSave(action: string) {
    const labourCodes = []; // "";
    labourCodes.push(this.resolveObject.labourData.Labour_Code);
    const objgatepass = {
      UserEmail: localStorage.getItem('UserEmailId'),
      //RoleCode: JSON.parse(localStorage.getItem('Role'))[0].Role_Code,
      RoleCode: this.approvalData.RoleCode,
      Request_Code: this.Request_Code,
      UserName: localStorage.getItem('UserName'),
      requestTypeCode: this.resolveObject.RequestType_Code,
      Action: action,
      labourcodes: labourCodes.join(','),
      UserId: GLOBAL.USER_ID,
      Comment: this.approvalData.HrComment,
      ULC: this.approvalData.ULCCode,
      verificationDate: this.approvalData.verificationDate,
      ESICVerificationDate: this.approvalData.ESICVerificationDate,
      IsVerifyEPF: this.approvalData.IsVerifyEPF,
      IsVerifyESIC: this.approvalData.IsVerifyESIC,
      // ULC : ULC,
      // GatePassNo : GatePassNo,
      EntityComplianceInfoView: {
        ContractorVendor_Code: this.approvalData.ContractorVendor_Code,
        State_Code: this.approvalData.State_Code,
        RegistrationNumber: this.approvalData.RegistrationNumber
      },
      // EIC
      GatePassValidityDate: moment(this.approvalData.gatepassValidityDate).format(this.sharedService.datePickerSettings.requestFormat),
      GatePassValidityDateHR: moment(this.approvalData.gatepassValidityDate).format(this.sharedService.datePickerSettings.requestFormat),
      Section: this.approvalData.SectionName,
      ShiftGroupView: {
        // ShiftGroupCode: this.approvalData.ShiftGroup_Code,
        SiteShiftGroupCode: [this.approvalData.SiteShiftGroup_Code],
        ULC: this.approvalData.ULC,
        Gatepassno: this.approvalData.Gatepassno,
        PlantCode: this.approvalData.PlantCode
      },
      // OHC
      FitnessStatus: this.approvalData.FitnessStatus,
      Checkupdate: moment(this.approvalData.CheckUpDate).format(this.sharedService.datePickerSettings.requestFormat),
      NextDuedate: moment(this.approvalData.OHCNextDuedate).format(this.sharedService.datePickerSettings.requestFormat),
      NextScheduledate: moment(this.approvalData.NextScheduledate).format(this.sharedService.datePickerSettings.requestFormat),
      From32: this.approvalData.From32,
      From35: this.approvalData.From35,
      XrayExaminationrequired: this.approvalData.examinationrequired,
      EyeTestingrequired: this.approvalData.eyetestingrequired ? this.approvalData.eyetestingrequired : null,
      TreatmentDetails: this.approvalData.TreatmentDetails,
      XrayValidityDate: moment(this.approvalData.XrayValidityDate).format(this.sharedService.datePickerSettings.requestFormat),
      ExaminationDetails: this.approvalData.ExaminationDetails,
      EyeTestingValidityDate: moment(this.approvalData.EyeTestingValidityDate).format(this.sharedService.datePickerSettings.requestFormat),
      NonHazardousDetails: this.approvalData.NonHazardousDetails,
      ReExamingDate: moment(this.approvalData.ReExamingDate).format(this.sharedService.datePickerSettings.requestFormat),
      // FNS
      InductionTraining: this.approvalData.InductionTraining,
      FNSTraningStatus: this.approvalData.FNSTraningStatus,
      FNSNextDuedate: moment(this.approvalData.FNSNextDuedate).format(this.sharedService.datePickerSettings.requestFormat),
      FNSNextScheduledate: moment(this.approvalData.FNSNextScheduledate).format(this.sharedService.datePickerSettings.requestFormat),
      FNSIsFireFighter: this.approvalData.FNSIsFireFighter,
      // Security
      Enrollment: this.approvalData.Enrollment,
      Gatepassissue: this.approvalData.Gatepassissue,
      // IssueDate: this.approvalData.IssueDate,
      Gatepassreturned: this.approvalData.Gatepassreturned,
      Gatepassdeactivated: this.approvalData.Gatepassdeactivated,
      HrComment: this.approvalData.HrComment,
      DocumentImageMasterViewModals: []
    };

    if (this.uploadedFiles.length) {
      this.uploadedFiles.forEach((file) => {
        if (file.isUploaded) {
          objgatepass.DocumentImageMasterViewModals.push({
            ID: file.ID,
            DocumentTypeMasterList_Code: file.documentTypeCode,
          });
        } else {
          objgatepass.DocumentImageMasterViewModals.push({
            DocumentTypeMasterList_Code: file.documentTypeCode,
          });
        }
      });
    }

    return objgatepass;
  }


  getPFNumber() {
    if (this.resolveObject && this.resolveObject.labourData && this.resolveObject.labourData.EPFNo) {
      return this.resolveObject.labourData.EPFNo;
    } else if (this.approvalData && this.approvalData.PFNo) {
      return this.approvalData.PFNo;
    }
    return '-';
  }

  getDateDetail() {
    const reqeustObj = {
      ULC: null,
      GatePassNo: null,
      Request_Code: this.Request_Code,
      RequestType_Code: null,
      Plant_Code: null,
      Contractor_Code: null,
      WorkOrder_Code: null,
      UserID: null,
      isCheck: 1
    };

    this.gatePassRequestsService.getMaxValidityDate(reqeustObj).subscribe((response) => {
      // let maxValidityDate = moment().add(6, 'months').format('YYYY-MM-DD');
      let maxValidityDate = this.approvalData.MaxValiditydate;
      if (response && response.date) {
        const d = this.globalSettingList.find(item => item.Code === 'MOD152PG195GPVDT');
        maxValidityDate = moment(response.date).add(d ? d : 0, 'days').format('YYYY-MM-DD');
        // maxValidityDate = moment(response.date).add(6, 'months').format('YYYY-MM-DD');
      }
      const modalRef = this.modalService.open(DateDetailsComponent, { ariaLabelledBy: 'modal-basic-title' });
      modalRef.componentInstance.approvalData = this.approvalData;
      modalRef.componentInstance.requestType = this.resolveObject.RequestType_Code;
      modalRef.componentInstance.maxValidityDate = new Date(maxValidityDate);
      modalRef.result.then((result) => {
        if (result) {
        }
      });
    })

  }

  // getDateDetail() {
  //   this.modalService.open(DateDetailsComponent, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
  //     this.closeResult = `Closed with: ${result}`;
  //   }, (reason) => {
  //     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //   });
  // }

  commentModel(isUpdateCall: boolean = false) {
    // modalRef.componentInstance.approvalData = this.approvalData;
    // modalRef.componentInstance.requestType = this.resolveObject.RequestType_Code;
    // modalRef.componentInstance.maxValidityDate = new Date(maxValidityDate);
    // modalRef.result.then((result) => {
    //   if (result) {
    //   }
    // });

    const modalRef = this.modalService.open(CommentComponent, {
      backdrop: 'static', windowClass: 'modal-scrollbar-hide'
    });
    modalRef.componentInstance.reqApprovalInfo = this.resolveObject;
    modalRef.componentInstance.approvalWorkFlowDetails = this.ApprovalWorkFlowDetails;
    modalRef.componentInstance.UserDataAccessData = this.UserDataAccessData;
    modalRef.componentInstance.reportingTo = this.reportingTo;

    modalRef.componentInstance.handleClose.subscribe((res: any) => {
      if (res) {
        // debugger;
        this.approvalData.RoleCode = res.userRoleCodes.join(',');
        this.approvalData.HrComment = res.HrComment;
        this.actionSaveData(isUpdateCall);
      }
      modalRef.close('')
    });
  }

  actionSave(isUpdateCall: boolean = false) {
    let isValid = false;
    if (isUpdateCall) {
      isValid = true;
    } else {
      isValid = this.checkvalidation();
    }
    if (isValid) {
      this.commentModel(isUpdateCall);
      // $scope.loading = true;
    }
  }

  actionSaveData(isUpdateCall: boolean = false) {
    const objgatepass: any = this.prepareReqForActionSave(this.action);
    objgatepass.isUpdateCall = isUpdateCall;
    let reqObj = {
      Labour_Code: this.resolveObject.labourData.Labour_Code
    }
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      this.fileUploadService.uploadFiles(this.uploadedFiles, reqObj, GLOBAL.APIS.CONTRACTOR_MANAGEMENT.UPLOAD_LABOUR_DOC).subscribe((res) => {
      });
    }
    this.gatePassRequestsService.actionSaveMulti(objgatepass).subscribe((msgdata: any) => {

  if (!msgdata.Data) {
    this.logHelperService.logError({ message: `Can't ${this.action} Data!` });
    this.stepclose(msgdata.Data);
    return;
  }

  if (objgatepass.requestTypeCode === 105) {
    this.logHelperService.logSuccess({ message: `${this.action} Gate Pass cancel!` });
    this.stepclose(msgdata.Data);
  } else {

    this.logHelperService.logSuccess({ message: `Data ${this.action} Successfully!` });
    this.stepclose(msgdata.Data);

    let StatusMasterList_Code: number;
    if (objgatepass.Action === 'Approved') StatusMasterList_Code = 256;
    else if (objgatepass.Action === 'Hold') StatusMasterList_Code = 248;
    else if (objgatepass.Action === 'Rejected') StatusMasterList_Code = 608;

    const roleCodes: number[] = objgatepass.RoleCode
      .toString()
      .split(',')
      .map(r => Number(r.trim()))
      .filter(r => !isNaN(r));

    roleCodes.forEach((roleCode) => {

      const meta = this.getApprovalMetaByRole(roleCode);

      const shareData = {
        Role_Code: roleCode,
        Name: meta.approvedByName,
        StatusMasterList_Code: StatusMasterList_Code,
        RequestedDate: moment(new Date()).format(this.sharedService.datePickerSettings.requestFormat),
        RequestedBy: GLOBAL.USER_ID,
        IsActive: true,
        IsDelete: false,
        Priority: meta.priority,
        IsLastLevel: meta.IsLastLevel,
        Request_Code: this.resolveObject.labourData.Request_Code,
        Level: meta.level,
      };

      this.dataShareService.shareData({
        function: "approveSelecteduser",
        type: "bulk-approval",
        data: shareData
      });
    });
  }
  
  this.gatePassRequestsService.sendMailForApproval(objgatepass);

}, (error) => {
  this.logHelperService.logError({ message: `Error in adding record!` });
});

  }
private getApprovalMetaByRole(roleCode: number) {
  let approvedByName = '';
  let priority: number;
  let level: number;
  let IsLastLevel = false;

  if (roleCode === 106 || roleCode === 107) {
    priority = 2;
    level = 2;
    approvedByName = roleCode === 106 ? 'Department Head' : 'Section Head';
  } else if (roleCode === 118 || roleCode === 121 || roleCode === 122) {
    approvedByName = 'Plant-HR';
    priority = 3;
    level = 3;
  } else if (roleCode === 109) {
    approvedByName = 'OHC';
    priority = 4;
    level = 4;
  } else if (roleCode === 110) {
    approvedByName = 'EHS';
    priority = 5;
    level = 5;
  } else if (roleCode === 111 || roleCode === 112) {
    approvedByName = 'Security';
    priority = 6;
    level = 6;
  }

  return { approvedByName, priority, level, IsLastLevel };
}

  getDocuments() {
    this.gatePassRequestsService.getDocumentForLabourVerify(this.resolveObject.labourData.Labour_Code)
      .subscribe((verificationDoc: any) => {
        if (verificationDoc.Status) {
          this.documents = verificationDoc.Data;
        }
      });
  }

  getAllSections() {
    this.gatePassRequestsService.getAllSections().subscribe((response: any) => {
      if (response.Status) {
        this.sections = response;
        if (this.approvalData.SectionName == null || this.approvalData.SectionName === '') {
        } else {
          const sectionMasterdata = [];
          this.sections.forEach((val) => {
            if (val.Name === this.approvalData.SectionName) {
              sectionMasterdata.push(val);
            }
          });
          if (sectionMasterdata.length === 1) {
            this.section = sectionMasterdata[0].Section_Code;
          }
        }
      }

    });
  }

  getMasterdata() {
    this.sharedDataService.getMasterData().subscribe((masterList: any) => {
      this.masterData = masterList.Data.Table;
      this.cardType = this.masterData.filter(list => list.Parent_Code === 601);
      this.regularweekly = [
        { Id: 1, Name: 'Sun' },
        { Id: 2, Name: 'Mon' }, { Id: 3, Name: 'Tue' },
        { Id: 4, Name: 'Wed' }, { Id: 5, Name: 'Thu' },
        { Id: 6, Name: 'Fri' }, { Id: 7, Name: 'Sat' }];
    });
  }

  shiftGroupData() {
    return this.gatePassRequestsService.getShiftGroupData().subscribe((res: any) => {
      this.shiftGroup = res.Data.Table;
    });
  }

  siteshiftGroupData() {
    return this.gatePassRequestsService.getSiteShiftGroupData().subscribe((res: any) => {
      this.siteshiftGroup = res.Data.Table;
      if (this.siteshiftGroup.length === 1) {
        this.approvalData.SiteShiftGroup_Code = this.siteshiftGroup[0].SiteShiftGroup_Code;
      }
    });
  }

  getIsAvailableRole(data: any) {
    const list = this.globalSettingList.find(item => item.Code === data);
    const list2 = list ? this.globalSettingList.find(item => item.Code === data).Role : null;
    const roles = JSON.parse(localStorage.getItem('Role'));
    const roleList: number[] = roles.map((roleItem: any) => roleItem.Role_Code);
    return list2 ? roleList.some(item => list2.includes(item)) : false;
  }

  private setActiveTabByRole() {
    const roles = JSON.parse(localStorage.getItem('Role'));
    const roleList: number[] = roles.map((roleItem: any) => roleItem.Role_Code);

    if (this.getIsAvailableRole('MOD52PG195REQVERROLL') && this.IsPrviousApproved === 1) {
      this.tabSet.activeId = 'tab-hr';
      // this.hr = true;
      this.hrverify = true;
      this.ohc = false;
      this.ehs = false;
      this.security = false;
      this.gpvaliditydate = true;
      this.disableenrollment = true;
    } else if (this.getIsAvailableRole('MOD52PG195REQFNSROLL')) {
      this.tabSet.activeId = 'tab-fns';
      // this.hr = false;
      this.hrverify = false;
      this.ohc = false;
      this.ehs = true;
      this.security = false;
      this.gpvaliditydate = false;
      this.disableenrollment = false;
    } else if (this.getIsAvailableRole('MOD52PG195REQOHCROLL')) {
      this.tabSet.activeId = 'tab-ohc';
      // this.hr = false;
      this.hrverify = false;
      this.ohc = true;
      this.ehs = false;
      this.security = false;
      this.gpvaliditydate = false;
      this.disableenrollment = false;
    } else if (this.getIsAvailableRole('MOD52PG195REQSECROLL')) {
      this.tabSet.activeId = 'tab-security';
      // this.hr = false;
      this.hrverify = false;
      this.ohc = false;
      this.ehs = false;
      this.security = true;
      this.gpvaliditydate = false;
      this.disableenrollment = false;
    }

    this.hrTabAllowedUser = roleList.some(item => this.allowedUserForNewRequestForHRTab.includes(item));
  }

  private hideFooterForContractor() {
    const roles = JSON.parse(localStorage.getItem('Role'));
    const roleList: number[] = roles.map((roleItem: any) => roleItem.Role_Code);
    if (roleList.includes(ROLECODE.Contractor)) {
      this.hideVerificationSection = true;
    }
  }

  checksixmonthdate(event: any) {
    console.log('Selected Date:', event);

    if (!event) return;

    const selectedDate = new Date(event);
    console.log('Converted Date:', selectedDate);

    // Check if selected date is greater than minValidityDate
    if (this.approvalData.minValidityDate) {
      const minDate = new Date(this.approvalData.minValidityDate);
      if (selectedDate.getTime() > minDate.getTime()) {
        this.logHelperService.logError({
          message: 'Selected date cannot be greater than the minimum validity date.'
        });

        this.approvalData.minValidityDate = null;
        return;
      }
    }

    if (!this.approvalData.gatepassValidityDate || selectedDate < new Date(this.approvalData.gatepassValidityDate)) {
      this.approvalData.gatepassValidityDate = selectedDate;
    }

    // const today = new Date();
    // let maxDate = new Date(today);
    // maxDate.setMonth(maxDate.getMonth() + 6);
    // maxDate.setDate(maxDate.getDate() - 1);


    // if (selectedDate.getTime() > maxDate.getTime()) {
    //   this.logHelperService.logError({
    //     message: 'Cannot add validity date greater than six months.'
    //   });

    //   this.approvalData.minValidityDate = null;
    //   this.approvalData.gatepassValidityDate = null;
    // }
  }


  checksixmonthdateeic(event) {
    if (typeof event === 'string') {
    } else if (event) {
      const validitydateeic = new Date(event);
      newdate1 = new Date(today.setMonth(today.getMonth() + 6));
      newdate1.setDate(newdate1.getDate() - 1);
      if (validitydateeic <= newdate1) {
        this.activedate = true;
      } else {
        this.logHelperService.logError({
          message: 'Can not add validity date greater than six month.'
        });
        this.approvalData.gatepassValidityDate = null;
        return;
      }
    }
  }

  addoneyeardate(event) {
    if (typeof event === 'string') {
    } else if (event) {
      //this.approvalData.OHCNextDuedate = event.add(this.nextDueDateCount, 'days');
      let checkupdate = moment(this.approvalData.CheckUpDate, "DD-MM-YYYY").toDate();
      let someDate = new Date(checkupdate.getFullYear() + '-' + (checkupdate.getMonth() + 1) + '-' + checkupdate.getDate());
      let result = someDate.setDate(someDate.getDate() + Number(this.nextDueDateCount));
      this.approvalData.OHCNextDuedate = new Date(result);
      this.onCheckedChangeEyeFunc("YES");
      // const validitydate = new Date(this.approvalData.CheckUpDate);
      // validitydate.setDate(validitydate.getUTCDate()+this.nextDueDateCount)
      // this.approvalData.OHCNextDuedate=validitydate
      // if (today === validitydate) {
      //   newdate = new Date(today.setMonth(today.getMonth() + 12));
      //   newdate.setDate(newdate.getDate() - 1);
      // } else {
      //   newdate = new Date(validitydate.setMonth(validitydate.getMonth() + 12));
      //   newdate.setDate(newdate.getDate() - 1);
      //   this.approvalData.OHCNextDuedate = newdate;
      //   return;
    }
  }

  addsixmonthdate(event) {
    if (typeof event === 'string') {
    } else {
      const extendeddate = new Date(event);
      if (today === extendeddate) {
        newdate = new Date(today.setMonth(today.getMonth() + 6));
        newdate.setDate(newdate.getDate() - 1);
      } else {
        newdate = new Date(extendeddate.setMonth(extendeddate.getMonth() + 6));
        newdate.setDate(newdate.getDate() - 1);
        this.approvalData.FNSNextScheduledate = newdate;
        return;
      }
    }
  }

  // tslint:disable-next-line: function-name
  IsVerifyEPF($event) {
    this.approvalData.IsVerifyEPF = $event.target.checked;
    if ($event.target.checked === true) {
      this.approvalData.verificationDate = today1;
      this.approvalData.UserforEPF = localStorage.getItem('UserName');
    } else {
      this.approvalData.verificationDate = null;
      this.approvalData.UserforEPF = null;
    }
  }

  // tslint:disable-next-line: function-name
  IsVerifyESIC($event) {
    this.approvalData.IsVerifyESIC = $event.target.checked;
    if ($event.target.checked === true) {
      this.approvalData.ESICVerificationDate = today1;
      this.approvalData.UserforESIC = localStorage.getItem('UserName');
    } else {
      this.approvalData.ESICVerificationDate = null;
      this.approvalData.UserforESIC = null;
    }
  }

  // tslint:disable-next-line: function-name
  IsVerifyDGMS($event) {
    if ($event.target.checked === true) {
      this.approvalData.dgmsVerificationDate = today1;
      this.approvalData.UserforDGMS = localStorage.getItem('UserEmailId');
    } else {
      this.approvalData.dgmsVerificationDate = null;
      this.approvalData.UserforDGMS = null;
    }
  }

  tabvalidation() {
    if (JSON.parse(localStorage.getItem('Role'))[0].Role_Code !== 107) {
      this.activedate = false;
      // this.gpvaliditydate = true;
    } else {
      this.activedate = true;
      // this.gpvaliditydate = false;
    }
  }
}
